var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41666 0.349072C6.30736 0.240426 6.15952 0.179443 6.00541 0.179443C5.8513 0.179443 5.70345 0.240426 5.59416 0.349072L3.49999 2.41407L1.43499 0.349072C1.3257 0.240426 1.17785 0.179443 1.02374 0.179443C0.869632 0.179443 0.721785 0.240426 0.61249 0.349072C0.557816 0.403301 0.514419 0.467818 0.484804 0.538903C0.455189 0.609987 0.439941 0.686232 0.439941 0.763239C0.439941 0.840246 0.455189 0.916491 0.484804 0.987576C0.514419 1.05866 0.557816 1.12318 0.61249 1.17741L3.08582 3.65074C3.14005 3.70541 3.20457 3.74881 3.27565 3.77843C3.34674 3.80804 3.42298 3.82329 3.49999 3.82329C3.577 3.82329 3.65324 3.80804 3.72433 3.77843C3.79541 3.74881 3.85993 3.70541 3.91416 3.65074L6.41666 1.17741C6.47133 1.12318 6.51473 1.05866 6.54434 0.987576C6.57396 0.916491 6.58921 0.840246 6.58921 0.763239C6.58921 0.686232 6.57396 0.609987 6.54434 0.538903C6.51473 0.467818 6.47133 0.403301 6.41666 0.349072Z",
    fill: "#4F5882"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.511039bbb6e6053fd6cb053d6ef87958.svg";
export { ForwardRef as ReactComponent };